<template>
  <div :class="className">
    <label :for="id">{{ label }}</label>
    <div class="base-input__select-wrap">
      <select
        :aria-describedby="describedBy"
        :aria-errormessage="errorMessage"
        :id="id"
        :name="$attrs.name"
        :value="value"
        v-bind="$attrs"
        type="text"
        :disabled="theme === 'disabled'"
        v-on="listeners"
        v-validate="validate"
      >
        <template v-if="groupedOptions">
          <option :value="null" hidden v-if="placeholder">{{ placeholder }}</option>
          <option :value="null" v-if="showNullOption"></option>
          <optgroup
            v-for="(group, index) in options"
            :key="index"
            :label="group.label"
          >
            <option :value="null"  hidden v-show="placeholder">{{ placeholder }}</option>
            <option v-for="item in group.options" :disabled="item.disabled" :key="item[valueKey]" :value="item[valueKey]">{{ item[labelKey] }}</option>
          </optgroup>
        </template>
        <template v-else>
          <option :value="null" disabled hidden v-if="placeholder">{{ placeholder }}</option>
          <option :value="null" v-if="showNullOption"></option>
          <option v-for="item in options" :disabled="item.disabled" :key="item[valueKey]" :value="item[valueKey]">{{ item[labelKey] }}</option>
        </template>
      </select>
      <BaseIcon name="double-arrows"/>
    </div>
    <TypographyInputError :id="errorMessageId" v-if="hasErrors">{{ errors.first($attrs.name) }}</TypographyInputError>
    <TypographyInputHint :id="hintId" v-if="hint">{{ hint }}</TypographyInputHint>
    <p class="base-input__learn" @click="learnAction" v-if="learnLabel && learnAction">{{ learnLabel }}</p>
  </div>
</template>

<script>
  import BaseInput from './BaseInput'

  export default {
    extends: BaseInput,
    props: {
      options: Array, // [ {label, value} ]
      labelKey: { default: 'label' },
      valueKey: { default: 'value' },
      placeholder: String,
      learnAction: Function,
      learnLabel: String,
      groupedOptions: Boolean,
      showNullOption: Boolean,
    },
    data () {
      return {
        id: null,
      }
    },
    mounted () {
      this.id = this._uid
    },
    computed: {
      hintId () {
        return this._uid + "-hint"
      },
      errorMessageId () {
        return this._uid + "-error"
      },
      describedBy () {
        if (this.hint) {
          return this.hintId
        }

        return ""
      },
      errorMessage () {
        if (this.hasErrors) {
          return this.errorMessageId
        }

        return ""
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/base/BaseSelect.vue